import type { IDoctorGroup } from '~/types'

interface IDoctorsApiConstructor {
  year: number
  region: string
}

export default class DoctorsApi {
  private readonly axios = axiosClient
  private readonly year: IDoctorsApiConstructor['year']
  private readonly region: IDoctorsApiConstructor['region']

  constructor(options: IDoctorsApiConstructor) {
    this.year = options.year
    this.region = options.region
  }

  async get(): Promise<IDoctorGroup[]> {
    try {
      const headers: { [key in string]: string } = {}
      const rawHeaders = useRequestHeaders()

      headers['x-forwarded-for-nuxt'] = rawHeaders['x-forwarded-for-nuxt']

      return await this.axios.$get(`/${this.year}/${this.region}/doctors/`, {
        headers,
      }, this.year)
    } catch {
      return await this.axios.$get(`/${this.year}/${this.region}/doctors/`, {}, this.year)
    }
  }

  async getData(): Promise<IDoctorGroup[]> { // ToDo переименовать в "get", а метод выше удалить во время удаления флага "replace_year_for_query_param"
    try {
      const headers: { [key in string]: string } = {}
      const rawHeaders = useRequestHeaders()

      headers['x-forwarded-for-nuxt'] = rawHeaders['x-forwarded-for-nuxt']

      return await this.axios.$get(`regions/${this.region}/doctors/`, {
        headers,
      }, this.year)
    } catch {
      return await this.axios.$get(`regions/${this.region}/doctors/`, {}, this.year)
    }
  }
}
